<template>
  <BModal
    :model-value="modelValue"
    centered
    @update:modelValue="handleModal"
    content-class="custom-modal-content"
    size="lg"
  >
    <template #header>
      <h5>{{ title }}</h5>
      <BButton variant="link" class="close" @click="handleModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <!-- Loading -->
    <div class="p-3 text-center" v-if="isLoading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Main Content -->
    <div class="custom-modal-body" v-else-if="restoBill?.reservation">
      <!-- Guest Info -->
      <div class="px-3 border-bottom">
        <p class="text-secondary fw-semibold mb-2">Guest Information</p>
        <!-- <ul class="guest">
          <li class="mb-1 d-flex gap-2">
            <span class="fw-semibold label">ID/Pasport</span>
            <span class="fw-semibold">:</span>
            <span class="fw-semibold">
              {{ restoBill.reservation.guest?.identity_number ?? "-" }}
            </span>
          </li>
          <li class="mb-1 d-flex gap-2">
            <span class="fw-semibold label">Name</span>
            <span class="fw-semibold">:</span>
            <span class="fw-semibold">
              {{ restoBill.reservation.guest?.fullname ?? "-" }}
            </span>
          </li>
          <li class="mb-1 d-flex gap-2">
            <span class="fw-semibold label">Contact</span>
            <span class="fw-semibold">:</span>
            <span class="fw-semibold">
              0{{ restoBill.reservation.guest?.phone ?? "-" }}
            </span>
          </li>
          <li class="mb-1 d-flex gap-2">
            <span class="fw-semibold label">Check In</span>
            <span class="fw-semibold">:</span>
            <span class="fw-semibold">
              {{ dateFormatter(restoBill.reservation.start) }}
            </span>
          </li>
          <li class="mb-1 d-flex gap-2">
            <span class="fw-semibold label">Check Out</span>
            <span class="fw-semibold">:</span>
            <span class="fw-semibold">
              {{ dateFormatter(restoBill.reservation.end) }}
            </span>
          </li>
          <li class="mb-1 d-flex gap-2">
            <span class="fw-semibold label">Stay Duration</span>
            <span class="fw-semibold">:</span>
            <span class="fw-semibold">
              {{
                countDays(
                  restoBill.reservation.start,
                  restoBill.reservation.end
                )
              }}
              hari
            </span>
          </li>
        </ul> -->
        <table class="w-full text-left border-collapse">
          <tbody>
              <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Order Number</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{ restoBill.reservation.number ?? "-" }}
                  </td>
              </tr>
              <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Name</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{ restoBill.reservation.guest?.fullname ?? "-" }}
                  </td>
              </tr>
              <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Contact</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                      0{{ restoBill?.reservation?.guest?.phone ?? '-' }}
                  </td>
              </tr>
              <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Check In</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                      {{ dateFormatter(restoBill.reservation.start) }}
                  </td>
              </tr>
                  <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Check Out</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                      {{ dateFormatter(restoBill.reservation.end) }}
                  </td>
              </tr>
              <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Stay Duration</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                      {{ countDays(
                        restoBill.reservation.start, 
                        restoBill.reservation.end) }}
                  </td>
              </tr>
          </tbody>
      </table>
      </div>

      <!-- Resto Bill -->
      <!-- codingan lama : madan -->
      <!-- <div class="p-3 border-bottom" v-if="restoBill?.resto_bill?.length">
        <p class="text-secondary fw-semibold mb-2">Billing Details</p>
        <div class="table-responsive">
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th class="text-left">Date</th>
                <th class="text-left">Order</th>
                <th class="text-left">Status</th>
                <th class="text-left">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(bill, index) in restoBill.resto_bill" :key="index">
                <td class="text-left">
                  {{ dateFormatter(bill.invoice_date) }}
                </td>
                <td class="text-left">
                  <ul class="list-unstyled mb-0">
                    <li
                      v-for="(item, itemIndex) in bill.items"
                      :key="itemIndex"
                      class="mb-1"
                    >
                      <div class="d-flex justify-content-between">
                        <span
                          >{{ item.name }} (x{{ item.quantity }})
                          {{ formatIDR(item.total) }}</span
                        >
                      </div>
                    </li>
                  </ul>
                </td>
                <td class="text-left">
                  <span
                    class="badge text-capitalize"
                    :class="{
                      'bg-success': bill.status === 'PAID',
                      'bg-warning': bill.status !== 'PAID',
                    }"
                  >
                    {{ bill.status }}
                  </span>
                </td>
                <td class="text-left">
                  {{
                    formatIDR(
                      bill.items.reduce((total, item) => total + item.total, 0)
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-end fw-bold" colspan="3">Total</td>
                <td class="text-left fw-bold">
                  {{
                    formatIDR(
                      restoBill?.resto_bill?.reduce(
                        (total, item) => total + item.invoice_total,
                        0
                      ) || 0
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> -->
      <div class="p-3 border-bottom" v-if="restoBill?.resto_bill?.length">
        <p class="text-secondary fw-semibold mb-2">Billing Details</p>
        <div class="table-responsive">
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th class="text-left">Date</th>
                <th class="text-left">Item</th>
                <th class="text-left">Status</th>
                <th class="text-left">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(bill, index) in restoBill.resto_bill" :key="index">
                <td class="text-left">
                  {{ dateFormatter(bill.invoice_date) }}
                </td>
                <td class="text-left">
                  <ul class="list-unstyled mb-0">
                    <li v-for="(item, i) in bill.items" :key="i">
                      {{ item.name }} x{{ item.quantity }} @{{ formatIDR(item.total) }}
                    </li>
                  </ul>
                </td>
                <td class="text-left">
                  <span
                    class="badge"
                    :class="{
                      'bg-success': bill.status === 'PAID',
                      'bg-warning': bill.status !== 'PAID',
                    }"
                  >
                    {{ bill.status }}
                  </span>
                </td>
                <td class="text-end fw-bold">
                  {{ formatIDR(bill.invoice_total) }}
                </td>
              </tr>

              <!-- summary -->
              <tr>
                <td colspan="3" class="text-end fw-bold">Sub Total</td>
                <td class="text-end fw-bold">
                  {{ formatIDR(
                    restoBill?.resto_bill?.reduce((t, b) => t + b.invoice_total, 0) || 0
                  ) }}
                </td>
              </tr>
              <tr>
                <td colspan="3" class="text-end fw-bold">Tax (10%)</td>
                <td class="text-end fw-bold">
                  {{ formatIDR(
                    restoBill?.resto_bill?.reduce((t, b) => t + b.tax, 0) || 0
                  ) }}
                </td>
              </tr>
              <tr>
                <td colspan="3" class="text-end fw-bold">Grand Total</td>
                <td class="text-end fw-bold">
                  {{ formatIDR(
                    restoBill?.resto_bill?.reduce((t, b) => t + b.grand_total, 0) || 0
                  ) }}
                </td>
              </tr>
            </tbody>

          </table>
        </div>
      </div>
    </div>
  </BModal>
</template>

<script>
import { ref, watch, inject } from "vue";
import { BModal, BButton } from "bootstrap-vue-next";
import { dateFormatter } from "@/utils/dateFormatter";
import { formatIDR } from "@/utils/currency";
import { countDays } from "@/utils/dateCalculation";

export default {
  components: {
    BModal,
    BButton,
  },
  props: {
    title: String,
    modelValue: Boolean,
    uuid: String,
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const repositories = inject("repositories");
    const restoBill = ref({});
    const isLoading = ref(false);
    const reservationRepository = repositories?.reservations;

    const handleModal = (val) => {
      emit("update:modelValue", val);
    };

    const getBill = async () => {
      if (!props.uuid) return;
      isLoading.value = true;
      try {
        const response = await reservationRepository.getBill(props.uuid);
        restoBill.value = response.data;
      } catch (err) {
        console.error("Failed to fetch bill:", err);
      } finally {
        isLoading.value = false;
      }
    };

    watch(
      () => props.modelValue,
      (val) => {
        if (val) getBill();
      }
    );

    return {
      restoBill,
      isLoading,
      handleModal,
      formatIDR,
      dateFormatter,
      countDays,
    };
  },
};
</script>

<style scoped>
.custom-modal-content {
  max-height: 90vh;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.custom-modal-body {
  overflow-y: auto;
  padding: 1rem;
  max-height: 70vh;
}
</style>
